export const PLANEMOS = [
    {
        id: 1,
        name: "Mercury",
        image: "/planemos/planemo-10px-mercury.png",
        desc: "A small rocky planet",
        height: 50,
        left: "20vw",
        top: "33vh",
    },
    {
        id: 2,
        name: "Venus",
        image: "/planemos/planemo-12px-venus.png",
        desc: "A medium-small cloud-covered planet",
        height: 60,
        left: "40vw",
        top: "33vh",
    },
    {
        id: 3,
        name: "Earth",
        image: "/planemos/planemo-12px-earth.png",
        desc: "A medium-small water-covered planet",
        height: 60,
        left: "60vw",
        top: "33vh",
    },
    {
        id: 4,
        name: "Mars",
        image: "/planemos/planemo-10px-mars.png",
        desc: "A small rust-covered planet",
        height: 50,
        left: "80vw",
        top: "33vh",
    },
    {
        id: 5,
        name: "Jupiter",
        image: "/planemos/planemo-24px-jupiter.png",
        desc: "A very large gas giant",
        height: 120,
        left: "20vw",
        top: "66vh"
    },
    {
        id: 6,
        name: "Saturn",
        image: "/planemos/planemo-20px-saturn.png",
        desc: "A large gas giant with rings",
        height: 100,
        left: "40vw",
        top: "66vh",
        rings: "/planemos/rings-20px-saturn.png",
        ringsWidth: 250,
    },
    {
        id: 7,
        name: "Uranus",
        image: "/planemos/planemo-16px-uranus.png",
        desc: "A medium-large ice giant",
        height: 80,
        left: "60vw",
        top: "66vh",
    },
    {
        id: 8,
        name: "Neptune",
        image: "/planemos/planemo-16px-neptune.png",
        desc: "A medium-large ice giant",
        height: 80,
        left: "80vw",
        top: "66vh",
    },
]